import React from 'react';
import { Alert, Container } from 'react-bootstrap';
import { useSelector } from 'react-redux';

import CustomTable from '../../../../../components/CustomTable';
import { customTableColumns } from './CustomTableColumns';
import FilterButtons from '../../../../../components/filter_buttons/FilterButtons';
import { getFilterButtonsConfig } from './filterButtonsConfig';


const ResultTables = ({setFilterTestDataMode}) => {
   const { surveyResults,
           isLoading,
           error } = useSelector(state => state.surveyResults);
   const columns = customTableColumns();
   const onFilter = () => setFilterTestDataMode(false);
   const onFilterTest = () => setFilterTestDataMode(true);
   const filterButtonsConfig = getFilterButtonsConfig(onFilterTest, onFilter);
  return (
    <Container className="mt-3">
      {
        error && <Alert variant="danger">{error}</Alert>
      }
      <div className="my-3">
        <FilterButtons justifyContent="justify-content-end" buttons={filterButtonsConfig} />
      </div>
      <CustomTable 
        columns={columns}
        data={surveyResults}
        isLoadingData={isLoading}
        isErrorToLoadData={!!error}
        maySortableRows={false} />
    </Container>
  )
}

export default ResultTables